// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 72076 ? "common" : chunkId) + "." + {"72076":"78394a2d76679494","79413":"7d6d488bbe9fed9d","87850":"1b5ef5691516f7e2","96554":"914d2cbeaf6ab838"}[chunkId] + ".css";
};